import { create } from 'zustand';
import { ConfirmationModalStore } from './index.types';

const initialState = {
  isOpen: false,
  onConfirm: undefined,
  onCancel: undefined,
  preventCloseOnClickOutside: false,
  testid: undefined,
  textConfirm: undefined,
  textCancel: undefined,
  description: undefined,
  title: undefined,
  size: undefined,
};

export const useConfirmationModalStore = create<ConfirmationModalStore>(
  (set, get) => ({
    ...initialState,
    setOpenConfirmationModal: ({
      onConfirm,
      onCancel,
      preventCloseOnClickOutside = false,
      testid,
      textConfirm,
      textCancel,
      description,
      title,
      size,
    }) => {
      set({
        isOpen: true,
        onConfirm,
        onCancel,
        preventCloseOnClickOutside,
        testid,
        textConfirm,
        textCancel,
        description,
        title,
        size,
      });
    },

    close: () => {
      set(initialState);
    },

    confirm: () => {
      const { onConfirm, close } = get();
      onConfirm?.();
      close();
    },

    cancel: () => {
      const { onCancel, close } = get();
      onCancel?.();
      close();
    },
  })
);
